import { ISetLayoutSidebarIsOpen } from './types';
import { LayoutActionTypes } from './constants';

export const setLayoutSidebarIsOpen = (payload: boolean): ISetLayoutSidebarIsOpen => ({
  type: LayoutActionTypes.SET_LAYOUT_SIDEBAR_IS_OPEN,
  payload,
});
